const SESSION_ID = 'error-reporter-session-id';

// Gets the session ID from sessionStorage or generates one
export function getErrorReporterSessionId() {
	if (typeof window === 'undefined' || typeof window.sessionStorage === 'undefined') {
		return '';
	}

	const sessionId = window.sessionStorage.getItem(SESSION_ID);
	if (sessionId) {
		return sessionId;
	}

	const newSessionId = crypto && crypto.randomUUID ? crypto.randomUUID() : '';
	window.sessionStorage.setItem(SESSION_ID, newSessionId);
	return newSessionId;
}
